let originalFaviconHref = null;
let faviconRequestId = 0;

function getFaviconLink() {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  return link;
}

function resolveFaviconHref(link) {
  const href = link.getAttribute('href') || '/favicon.ico';
  try {
    return new URL(href, window.location.origin).href;
  } catch {
    return href;
  }
}

export function setFaviconUnreadBadge(count) {
  if (typeof document === 'undefined') return;

  const link = getFaviconLink();
  if (originalFaviconHref == null) {
    originalFaviconHref = resolveFaviconHref(link);
  }

  if (!count || count <= 0) {
    faviconRequestId += 1;
    link.href = originalFaviconHref;
    return;
  }

  const requestId = ++faviconRequestId;
  const img = new Image();
  img.onload = () => {
    if (requestId !== faviconRequestId) return;

    const size = 32;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(img, 0, 0, size, size);

    const dotRadius = 7;
    ctx.fillStyle = '#ef4444';
    ctx.beginPath();
    ctx.arc(size - dotRadius, dotRadius, dotRadius, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.stroke();

    link.href = canvas.toDataURL('image/png');
  };
  img.onerror = () => {
    if (requestId !== faviconRequestId) return;
    link.href = originalFaviconHref;
  };
  img.src = originalFaviconHref;
}

export function clearFaviconUnreadBadge() {
  setFaviconUnreadBadge(0);
}
